import { liveDeployment } from "../presentation.js";
import type { ChatSnapshot as ConversationSnapshot } from "../types.js";

export function DeploymentStatus({ snapshot, stale = false }: {
  snapshot: ConversationSnapshot;
  stale?: boolean;
}) {
  const truth = snapshot.deployment;
  const live = liveDeployment(snapshot);
  const unknown = stale || !truth;
  const state = unknown ? "unknown" : live ? "live" : "not-live";
  const label = unknown ? "Status unavailable" : live ? "Live" : "Not live";
  const detail = unknown ? "Current deployment status is unavailable."
    : live ? "Release " + live.version + " is active."
    : truth?.activeDeployment
      ? "The retained deployment is " + truth.activeDeployment.state + ", while the app is " + truth.appState + "."
      : "No active deployment.";
  return <span className="a3-deployment-status" data-deployment-state={state} role="status"
    aria-label={label + ". " + detail} title={detail}>
    <span aria-hidden="true" />{label}
  </span>;
}
